<template>
  <el-card shadow="never">
    <span slot="header" style="font-weight: 600">次品</span>
    <Content :abnormal-type="abnormalDefective" abnormal="Client" uploadId="222" btnTitle="次品登记"
      @submitAbnormal="defectiveCall" ref="Client"></Content>
  </el-card>
</template>

<script>
import Content from "./Content";
import { abnormalDefective } from "@/types";
import { inHouseDoStockIn, getApplyCode, createSignFlow } from "@/apis/inHouse";

export default {
  name: "DefectiveSubmit",
  components: {
    Content
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      abnormalDefective
    }
  },
  methods: {
    defectiveCall: function (val) {
      console.log('de', val)
      let childen = this.$refs.Client;
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType = 2,
        relationRespDTOList,
        stockInNum,
        confirmNum,
        num,
        inboundCode
      } = this.record;
      if (Number(childen.abnormalAmount) + Number(stockInNum) + Number(confirmNum) > num) {
        this.$message.warning("超过采购总数");
        return;
      }
      let orderCode
      if (relationRespDTOList.length && relationRespDTOList[0].orderNo) {
        orderCode = relationRespDTOList[0].orderNo
      }else{
        this.$message.warning("订单号缺失，请联系技术人员");
        return 
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 2,
        exceptionCodeList: childen.abnormals
          .filter((item) => item.checked)
          .map((item) => item.value),
        picRelation: childen.qrCode,
        remark: childen.textarea,
        amount: childen.abnormalAmount,
        orderCode: orderCode,
        inboundCode:inboundCode,
        volume: 'XS'
      };
      if (params.exceptionCodeList.length == 0) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$emit('DoStockIn', data)
        }
      });
    }
  }
}
</script>

<style scoped>
</style>
